import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import HubIcon from "@mui/icons-material/Hub";
import HandshakeIcon from "@mui/icons-material/Handshake";
import PodcastsIcon from "@mui/icons-material/Podcasts";
import { styles } from "./styles";

const VALUES = [
  {
    Icon: HubIcon,
    title: "One Platform",
    description:
      "Course pages, onboarding, dashboards, scheduling, payments, messaging, video conferencing, and file storage: everything an organization needs to run live classes, under one roof.",
  },
  {
    Icon: HandshakeIcon,
    title: "True Partnership",
    description:
      "We host your course pages, onboard your instructors and students, and support your team as you grow. When your programs succeed, so do we.",
  },
  {
    Icon: PodcastsIcon,
    title: "Live-First",
    description:
      "We believe the best learning happens live. Everything we build is designed for real-time, interactive group classes, not recorded lectures.",
  },
];

export const About = () => {
  return (
    <Box>
      <Box sx={styles.heroSection}>
        <Container maxWidth="md">
          <Typography sx={styles.heroEyebrow}>Our Mission</Typography>
          <Typography variant="h1" sx={styles.heroHeadline}>
            Great teaching deserves great infrastructure.
          </Typography>
          <Typography sx={styles.heroSubtext}>
            We help academies, bootcamps, and training providers deliver
            world-class live learning online.
          </Typography>
        </Container>
      </Box>

      <Box sx={styles.storySection}>
        <Container maxWidth="md">
          <Typography component="h2" sx={styles.storyTitle}>
            Why we built Vulcan
          </Typography>
          <Typography sx={styles.storyParagraph}>
            Vulcan Learning started with a simple observation: education is a
            core pillar of our society, but the organizations that deliver it
            are forced to become software companies to do it well. Course pages
            on one platform, scheduling on another, payments on a third, and a
            video link held together with hope.
          </Typography>
          <Typography sx={styles.storyParagraph}>
            So we built the platform we wished existed: one place where an
            academy can host its course pages, onboard its instructors and
            students, schedule cohorts, collect payments, message everyone,
            teach live, and share materials. No duct tape required.
          </Typography>
          <Typography sx={styles.storyParagraph}>
            Today, Vulcan powers live group classes for education organizations,
            so the people who teach can spend their time teaching.
          </Typography>
        </Container>
      </Box>

      <Box sx={styles.valuesSection}>
        <Container maxWidth="lg">
          <Typography component="h2" sx={styles.valuesTitle}>
            What we stand for
          </Typography>
          <Grid container spacing={3} mt={4}>
            {VALUES.map(({ Icon, title, description }) => (
              <Grid key={title} xs={12} md={4}>
                <Box sx={styles.valueCard}>
                  <Box sx={styles.valueIconCircle}>
                    <Icon />
                  </Box>
                  <Typography sx={styles.valueTitle}>{title}</Typography>
                  <Typography sx={styles.valueDescription}>
                    {description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default About;
